const fmt = (v, prefix) => `${prefix}${Math.round(Number(v) || 0).toLocaleString("en-US")}`;
export const fmtUSD = (v) => fmt(v, "$");
export const fmtCAD = (v) => fmt(v, "C$");

// USD value with the original CAD amount underneath for CAD estimations; optional awarded part for partial awards.
export const MoneyCell = ({ usd, native, currency, testId, awardedUsd, awardedNative }) => (
  <div className="whitespace-nowrap" data-testid={testId}>
    <div>{fmtUSD(usd)}</div>
    {currency === "CAD" && <div className="text-xs text-gray-500">({fmtCAD(native)})</div>}
    {awardedUsd != null && (
      <div className="text-xs text-green-700 font-medium" data-testid={testId ? `${testId}-awarded` : undefined}>
        Awarded: {fmtUSD(awardedUsd)}{currency === "CAD" ? ` (${fmtCAD(awardedNative)})` : ""}
      </div>
    )}
  </div>
);

// "USD · n  $x" / "CAD · n  C$y" breakdown used on the Sales metric cards.
export const CurrencySplit = ({ bucket, tone = "text-gray-700", testId }) => {
  const usd = bucket?.by_currency?.USD || { count: 0, value: 0 };
  const cad = bucket?.by_currency?.CAD || { count: 0, value: 0, usd_value: 0 };
  if (!cad.count) return null;
  return (
    <div className={`mt-3 pt-2 border-t border-black/10 space-y-0.5 text-xs ${tone}`} data-testid={testId}>
      <div className="flex justify-between"><span>USD · {usd.count}</span><span className="font-mono font-semibold">{fmtUSD(usd.value)}</span></div>
      <div className="flex justify-between"><span>CAD · {cad.count}</span><span className="font-mono font-semibold">{fmtCAD(cad.value)} <span className="font-normal opacity-70">≈ {fmtUSD(cad.usd_value)}</span></span></div>
    </div>
  );
};
